export const SET_REVIEW_SEARCH = 'SET_REVIEW_SEARCH';
export const setReviewSearch = (entityId, entityType, reviewSearch) => ({
  type: SET_REVIEW_SEARCH,
  entityId,
  data: reviewSearch,
  entityType,
});
